import {
  CreateStowageInstructionCommand,
  StowageInstructionsApi,
  StowageInstructionsApiStowageInstructionsDeleteRequest,
  UpdateStowageInstructionCommand,
} from '@storage/app/api'
import { createApiClient } from '@storage/app/http-client'

class StowageInstructionService {
  httpClient = createApiClient(StowageInstructionsApi)

  async load() {
    const { data } = await this.httpClient.stowageInstructionsGetAll()
    return data
  }

  async update(cmd: UpdateStowageInstructionCommand) {
    const { data } = await this.httpClient.stowageInstructionsUpdate({
      updateStowageInstructionCommand: cmd,
    })
    return data
  }

  async create(cmd: CreateStowageInstructionCommand) {
    const { data } = await this.httpClient.stowageInstructionsCreate({
      createStowageInstructionCommand: cmd,
    })
    return data
  }

  async delete(cmd: StowageInstructionsApiStowageInstructionsDeleteRequest) {
    const { data } = await this.httpClient.stowageInstructionsDelete(cmd)
    return data
  }
}

const stowageInstructionService = new StowageInstructionService()

export default stowageInstructionService
